export default __webpack_public_path__ + "static/media/Physics01_02.9849f1ab.png";